module.exports = __webpack_public_path__ + "img/avatar.b30248d4.b30248d4.svg";